import { LocaleProvider } from '@vp/digital-locale-lib-ubik'
import { IdentityProvider, VPAuthConfig } from '@vp/ubik-context'
import WixNewAnonymousPlansPage from './src/WixNewAnonymousPlansPage'
import { PricingContentProvider, PricingContextProvider } from '@vp/digital-pricing-lib-ubik'
import { getClientEnvironment, RuntimeContextProvider } from '@vp/digital-environment-lib-ubik'
import { WixPageAnalyticsProvider } from '../common/helpers/WixPageAnalyticsProvider'

export function WixAnonymousPlansApp(props: any) {
  const createAuthConfig = (culture: string, isDevelopment: boolean): VPAuthConfig => ({
    culture,
    developmentMode: isDevelopment,
    options: {
      requireSession: true,
      customText: 'Sign in to see your account',
    },
  })

  return (
    <LocaleProvider rawLocaleIdentifier={props.locale}>
      <RuntimeContextProvider getEnvironment={getClientEnvironment}>
        <IdentityProvider auth={createAuthConfig(props.locale, false)}>
          <PricingContextProvider>
            <PricingContentProvider pricingContent={props.billingPeriods}>
              <WixPageAnalyticsProvider pageAnalyticsData={props.pageAnalyticsData} productKey={props.mpv.productKey}>
                <WixNewAnonymousPlansPage {...props} />
              </WixPageAnalyticsProvider>
            </PricingContentProvider>
          </PricingContextProvider>
        </IdentityProvider>
      </RuntimeContextProvider>
    </LocaleProvider>
  )
}
